// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_floatingTextFormatBottom__Pa681 {
  display: flex;
  background: #fff;
  padding: 7px;
  vertical-align: middle;
  position: absolute;
  opacity: 0;
  z-index: 100;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  border: 1px solid rgba(230, 233, 237, 1);
  transition: opacity 0.5s;
  will-change: transform;
}

.styles_floatingTextFormatPopup__4kyRa button.styles_popup-item__tPZO1 {
  display: flex;

  padding: 8px;

  cursor: pointer;
  vertical-align: middle;

  border: 0;
  border-radius: 10px;
  background: none;
}

.styles_floating-text-format-popup__8fWjS button.styles_popup-item__tPZO1:disabled {
  cursor: not-allowed;
}

.styles_floating-text-format-popup__8fWjS button.styles_popup-item__tPZO1.styles_spaced__GEwiK {
  margin-right: 2px;
}

.styles_floating-text-format-popup__8fWjS button.styles_popup-item__tPZO1 i.styles_format__xEdRu {
  display: flex;

  width: 18px;
  height: 18px;
  margin-top: 2px;

  vertical-align: -0.25em;

  opacity: 0.6;
  background-size: contain;
}

.styles_floating-text-format-popup__8fWjS button.styles_popup-item__tPZO1:disabled i.styles_format__xEdRu {
  opacity: 0.2;
}

.styles_floating-text-format-popup__8fWjS button.styles_popup-item__tPZO1.styles_active__TxJnr {
  background-color: rgb(223 232 250 / 30%);
}

.styles_floating-text-format-popup__8fWjS button.styles_popup-item__tPZO1.styles_active__TxJnr i {
  opacity: 1;
}

.styles_floating-text-format-popup__8fWjS .styles_popup-item__tPZO1:hover:not([disabled]) {
  background-color: #eee;
}

.styles_floating-text-format-popup__8fWjS select.styles_popup-item__tPZO1 {
  display: flex;

  width: 70px;
  padding: 8px;

  vertical-align: middle;
  width: 70px;
  font-size: 14px;
  color: #777;
  text-overflow: ellipsis;

  color: #777;
  border: 0;
  border-radius: 10px;
  background: none;

  font-size: 14px;
  -webkit-appearance: none;
          appearance: none;
  appearance: none;
}

.styles_floating-text-format-popup__8fWjS select.styles_code-language__ntPEM {
  width: 130px;

  text-transform: capitalize;
}

.styles_floating-text-format-popup__8fWjS .styles_popup-item__tPZO1 .styles_text__N\\+0cL {
  display: flex;
  overflow: hidden;

  width: 70px;
  height: 20px;

  text-align: left;
  vertical-align: middle;
  text-overflow: ellipsis;

  color: #777;

  font-size: 14px;
  line-height: 20px;
}

.styles_separator__A3-CI {
  width: 2px;
  height: 15px;
  margin: 0 10px;

  background-color: rgba(230, 233, 237, 1);
}
`, "",{"version":3,"sources":["webpack://./src/components/form/Editor/plugins/FloatingTextFormatToolbarPlugin/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,wCAAwC;EACxC,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,aAAa;;EAEb,YAAY;;EAEZ,eAAe;EACf,sBAAsB;;EAEtB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;;EAEb,WAAW;EACX,YAAY;EACZ,eAAe;;EAEf,uBAAuB;;EAEvB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;;EAEb,WAAW;EACX,YAAY;;EAEZ,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,WAAW;EACX,uBAAuB;;EAEvB,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,gBAAgB;;EAEhB,eAAe;EACf,wBAAgB;UAAhB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;;EAEZ,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,gBAAgB;;EAEhB,WAAW;EACX,YAAY;;EAEZ,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;;EAEvB,WAAW;;EAEX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,cAAc;;EAEd,wCAAwC;AAC1C","sourcesContent":[".floatingTextFormatBottom {\n  display: flex;\n  background: #fff;\n  padding: 7px;\n  vertical-align: middle;\n  position: absolute;\n  opacity: 0;\n  z-index: 100;\n  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.3);\n  border-radius: 8px;\n  border: 1px solid rgba(230, 233, 237, 1);\n  transition: opacity 0.5s;\n  will-change: transform;\n}\n\n.floatingTextFormatPopup button.popup-item {\n  display: flex;\n\n  padding: 8px;\n\n  cursor: pointer;\n  vertical-align: middle;\n\n  border: 0;\n  border-radius: 10px;\n  background: none;\n}\n\n.floating-text-format-popup button.popup-item:disabled {\n  cursor: not-allowed;\n}\n\n.floating-text-format-popup button.popup-item.spaced {\n  margin-right: 2px;\n}\n\n.floating-text-format-popup button.popup-item i.format {\n  display: flex;\n\n  width: 18px;\n  height: 18px;\n  margin-top: 2px;\n\n  vertical-align: -0.25em;\n\n  opacity: 0.6;\n  background-size: contain;\n}\n\n.floating-text-format-popup button.popup-item:disabled i.format {\n  opacity: 0.2;\n}\n\n.floating-text-format-popup button.popup-item.active {\n  background-color: rgb(223 232 250 / 30%);\n}\n\n.floating-text-format-popup button.popup-item.active i {\n  opacity: 1;\n}\n\n.floating-text-format-popup .popup-item:hover:not([disabled]) {\n  background-color: #eee;\n}\n\n.floating-text-format-popup select.popup-item {\n  display: flex;\n\n  width: 70px;\n  padding: 8px;\n\n  vertical-align: middle;\n  width: 70px;\n  font-size: 14px;\n  color: #777;\n  text-overflow: ellipsis;\n\n  color: #777;\n  border: 0;\n  border-radius: 10px;\n  background: none;\n\n  font-size: 14px;\n  appearance: none;\n  appearance: none;\n}\n\n.floating-text-format-popup select.code-language {\n  width: 130px;\n\n  text-transform: capitalize;\n}\n\n.floating-text-format-popup .popup-item .text {\n  display: flex;\n  overflow: hidden;\n\n  width: 70px;\n  height: 20px;\n\n  text-align: left;\n  vertical-align: middle;\n  text-overflow: ellipsis;\n\n  color: #777;\n\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.separator {\n  width: 2px;\n  height: 15px;\n  margin: 0 10px;\n\n  background-color: rgba(230, 233, 237, 1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"floatingTextFormatBottom": `styles_floatingTextFormatBottom__Pa681`,
	"floatingTextFormatPopup": `styles_floatingTextFormatPopup__4kyRa`,
	"popup-item": `styles_popup-item__tPZO1`,
	"floating-text-format-popup": `styles_floating-text-format-popup__8fWjS`,
	"spaced": `styles_spaced__GEwiK`,
	"format": `styles_format__xEdRu`,
	"active": `styles_active__TxJnr`,
	"code-language": `styles_code-language__ntPEM`,
	"text": `styles_text__N+0cL`,
	"separator": `styles_separator__A3-CI`
};
export default ___CSS_LOADER_EXPORT___;
